// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type Note } from '../reusable/Notes'

export type CreateNoteParams = {
  content: string
}

type CreateNoteMutationArgs = {
  memberId?: string
  employerId?: string
  subjectId?: string
  subjectType?: string
}

export function useCreateNote ({
  memberId,
  employerId,
  subjectId,
  subjectType,
}: CreateNoteMutationArgs) {
  return useMutation<Note, GrapeAPIErrorType, CreateNoteParams>({
    mutationFn: async (params) => {
      const request = new FetchRequest('post', '/api/web/brokers/notes', {
        body: {
          member_id: memberId,
          employer_id: employerId,
          subject_id: subjectId,
          subject_type: subjectType,
          ...params,
        },
      })
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
